import { createSlice } from '@reduxjs/toolkit';
import { NARROW_LAYOUT } from 'UTILS/constants';

export const initialState = {
  layout: NARROW_LAYOUT,
  hasPermissions: false,
  relayServers: {},
  isVerbose: true,
  backUrl: null,
  closeOnBack: false,
  supportPhoneNumber: null,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    init(state) {},
    layoutChange(state, { payload: { layout } }) {
      state.layout = layout;
    },
    permissionsRequest() {},
    permissionsSuccess(state) {
      state.hasPermissions = true;
    },
    permissionsError(state) {
      state.hasPermissions = false;
    },
    deviceListUpdate() {},
  },
});

export const {
  init,
  layoutChange,
  permissionsRequest,
  permissionsSuccess,
  permissionsError,
  deviceListUpdate,
} = appSlice.actions;
export default appSlice.reducer;
